/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";

import {
	StyleSheet,
	View,
} from "react-native";

import Style from "ae-style";
import StyledText from "ae-base/Base/StyledText";
import StyledIcon from "ae-base/Base/StyledIcon";

import { useResources } from "@aetonix/hooks";

const styles = StyleSheet.create({
	container: {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        margin: Style.layout.marginSmall / 2,
        maxWidth: Style.layout.squareButton,
    },
    textarea: {
        alignItems: "flex-start",
        maxWidth: "100%",
        padding: 5,
    },
});

export default function OutputStatus(props) {
	const { localize, localizeFrom } = useResources();
	const schema = props.schema;
	const data = props.data;
	const large = props.large;
	const description = schema.description;

	let label;

	if (schema.localization) {
		label = localizeFrom(schema.localization, ".");
	} else if (description) {
		label = localize(description) || description;
	} else {
		return null;
	}

	let color = Style.colors.gray;
	if(!data) {
		color = Style.colors.green;
	} else if(data === 1) {
		color = Style.colors.yellow;
	} else if(data === 2) {
		color = Style.colors.red;
	}

	const iconName = schema.icon || "files";

	return large ? (
		<View style={styles.container}>
			<StyledIcon color={color} name={iconName} hugeHeading />
			<View style={styles.textarea}>
				<StyledText light small contrast >{label}</StyledText>
			</View>
		</View>) : (
		<View style={styles.container}>
			<StyledIcon color={color} name={iconName} largeHeading />
			<View style={styles.textarea}>
				<StyledText light small black>{label}</StyledText>
			</View>
		</View>
	);
}